/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
var pDefer = () => {
	const ret = {};

	ret.promise = new Promise((resolve, reject) => {
		ret.resolve = resolve;
		ret.reject = reject;
	});

	return ret;
};

export { pDefer as p };
